import { render } from "./Pagination.vue?vue&type=template&id=241a5142"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Pagination.vue?vue&type=style&index=0&id=241a5142&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script